import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Field, FieldLabel } from "@/components/ui/field";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export function ResolveFlagDialog({
  open,
  onOpenChange,
  onSubmit,
  submitting,
  initialReply,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (reply: string) => void;
  submitting: boolean;
  initialReply?: string;
}) {
  const [reply, setReply] = useState("");

  useEffect(() => {
    if (open) setReply(initialReply ?? "");
    else setReply("");
  }, [open, initialReply]);

  function submit() {
    onSubmit(reply);
  }

  return (
    <Dialog
      open={open}
      onOpenChange={next => {
        onOpenChange(next);
        if (!next) setReply("");
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Mark resolved</DialogTitle>
          <DialogDescription>Optional note for the reviewer.</DialogDescription>
        </DialogHeader>
        <Field>
          <FieldLabel>Note</FieldLabel>
          <Textarea
            value={reply}
            onChange={e => setReply(e.target.value)}
            rows={3}
            maxLength={500}
            placeholder="e.g. retaken page 2, re-uploaded"
          />
        </Field>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={submit} disabled={submitting}>
            Mark resolved
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
